exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-058e4fe6]{margin-top:12px}", ""]);

// exports
